<template>
    <div v-if="label">
        <h2 class="subtitle">{{label.titles.title}} <Info multilined bottom :tooltipText="label.texts.titleTooltip"/></h2>
        <div>
          <!-- Table -->
          <div class="table-container">
            <table class="table is-hoverable">
              <thead>
                <tr>
                  <th>{{label.forms.addressName}}</th>
                  <th>{{label.forms.street}}</th>
                  <th>{{label.forms.number}}</th>
                  <th>{{label.forms.box}}</th>
                  <th>{{label.forms.zipcode}}</th>
                  <th>{{label.forms.city}}</th>
                  <th>{{label.forms.country}}</th>
                  <th class="has-text-centered"><div class="large-col">{{label.forms.actions}}</div></th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr>
                  <td
                    class="add-address has-text-centered"
                    colspan="20"
                    @click="openCreateModal()">
                    <awesome-icon class="button-icon" icon="plus"/>{{label.buttons.addAddress}}
                  </td>
                </tr> -->
                <tr v-for="address of addresses" :key="address.id">
                  <td>{{address.customName}}</td>
                  <td>{{address.streetName}}</td>
                  <td>{{address.streetNumber}}</td>
                  <td>{{address.boxNumber ? address.boxNumber : '/'}}</td>
                  <td>{{address.postalCode}}</td>
                  <td>{{address.localityName}}</td>
                  <td>{{address.country}}</td>
                  <td class="has-text-centered">
                    <!-- <a class="button is-outlined is-dark is-small" style="margin-right: 10px;"  @click="openDetailModal(address)">Détails</a> -->
                    <a class="button is-outlined is-info is-small" style="margin-right: 10px;" @click="openEditModal(address)">{{label.buttons.edit}}</a>
                    <!-- <button :disabled="address.source != 'user' " class="button is-outlined is-danger is-small" @click="deleteLocation(address)">{{label.buttons.delete}}</button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="modal" :class="{ 'is-active': showDetailModal }">
            <div class="modal-background" @click="cancelModal()"></div>
            <div class="modal-content" v-if="selectedLocation">
              <div class="box">
                <h1 class="title">{{label.titles.addressDetail}}</h1>
                <!-- <p style="margin-bottom:1rem">{{label.texts.addressDetailDescription}}</p> -->

                <p class="field">
                  <strong>{{label.texts.address}} :</strong> {{selectedLocation.customName}}
                </p>

                <!-- <div v-if="metaData">
                  <div class="field"><strong>{{label.forms.buildingType}} :</strong> {{metaDataForm.buildingType}}</div>

                  <div class="field"><strong>{{label.forms.nbInhabitants}} :</strong> {{metaDataForm.nbInhabitants}}</div>

                  <div class="field"><strong>{{label.forms.surface}} :</strong> {{metaDataForm.surface}}</div>

                  <div class="field"><strong>{{label.forms.constructionYear}} :</strong> {{metaDataForm.constructionYear}}</div>

                  <div class="field"><strong>{{label.forms.isLowConsumption}} :</strong> {{formatRadioValue(metaDataForm.isLowConsumption)}}</div>

                  <div class="field"><strong>{{label.forms.hasConvertedAttic}} :</strong> {{formatRadioValue(metaDataForm.hasConvertedAttic)}}</div>

                  <div class="field"><strong>{{label.forms.hasMultipleFloors}} :</strong> {{formatRadioValue(metaDataForm.hasMultipleFloors)}}</div>

                  <div class="field"><strong>{{label.forms.hasVeranda}} :</strong> {{formatRadioValue(metaDataForm.hasVeranda)}}</div>

                  <div class="field"><strong>{{label.forms.isTerracedHouse}} :</strong> {{formatRadioValue(metaDataForm.isTerracedHouse)}}</div>

                  <div class="field"><strong>{{label.forms.ceilingHeight}} :</strong> {{metaDataForm.ceilingHeight}}</div>

                  <div class="field"><strong>{{label.forms.hasPool}} :</strong> {{formatRadioValue(metaDataForm.hasPool)}}</div>

                  <div class="field"><strong>{{label.forms.temperature}} :</strong> {{metaDataForm.temperature}}</div>

                  <div class="field"><strong>{{label.forms.reduceHeatingWhenAbsent}} :</strong> {{formatRadioValue(metaDataForm.reduceHeatingWhenAbsent)}}</div>

                  <div class="field"><strong>{{label.forms.alwaysSomeoneAtHome}} :</strong> {{formatRadioValue(metaDataForm.alwaysSomeoneAtHome)}}</div>

                  <div class="field"><strong>{{label.forms.useLowConsumptionBulbs}} :</strong> {{formatRadioValue(metaDataForm.useLowConsumptionBulbs)}}</div>

                  <div class="field"><strong>{{label.forms.useAirConditioner}} :</strong> {{formatRadioValue(metaDataForm.useAirConditioner)}}</div>
                </div>

                <div v-else class="notification is-info">{{label.texts.noDetail}}</div> -->

                <div class="field is-grouped">
                  <p class="control">
                    <a class="button is-light" @click="cancelModal()">{{label.buttons.close}}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Create/edit modal -->
          <div class="modal" :class="{ 'is-active': showEditAddress || showCreateAddress }">
            <div class="modal-background" @click="cancelModal()"></div>
            <div class="modal-content">
              <div class="box">
                <h1 class="title">{{showCreateAddress ? label.titles.titleModalCreate : label.titles.titleModalEdit}}</h1>
                <!-- <p style="margin-bottom:1rem" v-if="!userAddress">{{label.texts.userAddress}}</p> -->

                <form @submit.prevent="submitAddress">
                  <!-- <h2 class="subtitle">{{label.titles.generalInfo}}</h2> -->

                  <!-- Nom personnalisé -->
                  <div class="field">
                    <label class="label">{{label.forms.addressName}}*</label>
                    <div class="control">
                      <input required class="input" type="text" maxlength="300" v-model="addressToSubmit.customName">
                    </div>
                  </div>

                  <div class="horizontal-wrapper">
                    <!-- Rue -->
                    <div class="field">
                      <label class="label">{{label.forms.street}}*</label>
                      <div class="control">
                        <input required class="input input-large" type="text" maxlength="300" :disabled="!userAddress" v-model="addressToSubmit.streetName">
                      </div>
                    </div>

                    <!-- Numéro -->
                    <div class="field">
                      <label class="label">{{label.forms.number}}*</label>
                      <div class="control">
                        <input required class="input input-small" type="text" maxlength="20" :disabled="!userAddress" v-model="addressToSubmit.streetNumber">
                      </div>
                    </div>

                    <!-- N° de boite -->
                    <div class="field">
                      <label class="label">{{label.forms.box}}</label>
                      <div class="control">
                        <input class="input input-small" type="text" maxlength="20" :disabled="!userAddress" v-model="addressToSubmit.boxNumber">
                      </div>
                    </div>
                  </div>

                  <div class="horizontal-wrapper">
                    <!-- Code postal -->
                    <div class="field">
                      <label class="label">{{label.forms.zipcode}}*</label>
                      <div class="control">
                        <input required class="input input-small" type="text" maxlength="20" :disabled="!userAddress" v-model="addressToSubmit.postalCode">
                      </div>
                    </div>

                    <!-- Ville -->
                    <div class="field">
                      <label class="label">{{label.forms.city}}*</label>
                      <div class="control">
                        <input required class="input input-medium" type="text" maxlength="200" :disabled="!userAddress" v-model="addressToSubmit.localityName">
                      </div>
                    </div>

                    <!-- Pays -->
                    <div class="field">
                      <label class="label">{{label.forms.country}}*</label>
                      <div class="control">
                        <input required class="input input-medium" type="text" maxlength="200" :disabled="!userAddress" v-model="addressToSubmit.country">
                      </div>
                    </div>
                  </div>

                  <!-- <h2 class="subtitle" style="margin-top:1rem; margin-bottom:0.5rem">{{label.texts.details}}</h2> -->
                  <!-- <p style="margin-bottom:1rem">{{label.texts.detailsDescription}}</p> -->

                  <!-- <div v-if="metaData || newMetadata"> -->
                    <!-- buildingType -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.buildingType}}</label>
                      <div class="control">
                        <input class="input" type="text" maxlength="200" v-model="metaDataForm.buildingType">
                      </div>
                    </div> -->

                    <!-- <div class="horizontal-wrapper"> -->
                      <!-- nbInhabitants -->
                      <!-- <div class="field">
                        <label class="label">{{label.forms.nbInhabitants}}</label>
                        <div class="control">
                          <input class="input input-small" type="number" v-model="metaDataForm.nbInhabitants">
                        </div>
                      </div> -->

                      <!-- surface -->
                      <!-- <div class="field">
                        <label class="label">{{label.forms.surface}} (m²)</label>
                        <div class="control">
                          <input class="input input-small" type="number" v-model="metaDataForm.surface">
                        </div>
                      </div> -->

                      <!-- constructionYear -->
                      <!-- <div class="field">
                          <label class="label">{{label.forms.constructionYear}}</label>
                          <div class="control">
                            <input class="input input-small" type="number" v-model="metaDataForm.constructionYear">
                          </div>
                        </div>
                      </div> -->

                    <!-- isLowConsumption -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.isLowConsumption}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.isLowConsumption">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.isLowConsumption">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.isLowConsumption">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div> -->

                    <!-- hasConvertedAttic -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.hasConvertedAttic}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.hasConvertedAttic">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.hasConvertedAttic">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.hasConvertedAttic">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div> -->

                    <!-- hasMultipleFloors -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.hasMultipleFloors}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.hasMultipleFloors">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.hasMultipleFloors">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.hasMultipleFloors">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div> -->

                    <!-- hasVeranda -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.hasVeranda}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.hasVeranda">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.hasVeranda">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.hasVeranda">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div> -->

                    <!-- isTerracedHouse -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.isTerracedHouse}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.isTerracedHouse">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.isTerracedHouse">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.isTerracedHouse">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div> -->

                    <!-- ceilingHeight -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.ceilingHeight}}</label>
                      <div class="control">
                        <input class="input input-medium" type="number" v-model="metaDataForm.ceilingHeight">
                      </div>
                    </div> -->

                    <!-- hasPool -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.hasPool}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.hasPool">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.hasPool">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.hasPool">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div> -->

                    <!-- temperature -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.temperature}}</label>
                      <div class="control">
                        <input class="input input-medium" type="number" v-model="metaDataForm.temperature">
                      </div>
                    </div> -->

                    <!-- reduceHeatingWhenAbsent -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.reduceHeatingWhenAbsent}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.reduceHeatingWhenAbsent">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.reduceHeatingWhenAbsent">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.reduceHeatingWhenAbsent">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div> -->

                    <!-- alwaysSomeoneAtHome -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.alwaysSomeoneAtHome}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.alwaysSomeoneAtHome">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.alwaysSomeoneAtHome">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.alwaysSomeoneAtHome">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div> -->

                    <!-- useLowConsumptionBulbs -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.useLowConsumptionBulbs}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.useLowConsumptionBulbs">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.useLowConsumptionBulbs">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.useLowConsumptionBulbs">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div> -->

                    <!-- useAirConditioner -->
                    <!-- <div class="field">
                      <label class="label">{{label.forms.useAirConditioner}}</label>
                      <div class="control">
                        <label class="radio">
                          <input type="radio" :value="null" v-model="metaDataForm.useAirConditioner">
                          --
                        </label>
                        <label class="radio">
                          <input type="radio" :value="true" v-model="metaDataForm.useAirConditioner">
                          {{label.buttons.yes}}
                        </label>
                        <label class="radio">
                          <input type="radio" :value="false" v-model="metaDataForm.useAirConditioner">
                          {{label.buttons.no}}
                        </label>
                      </div>
                    </div>
                  </div> -->

                  <!-- <div class="field is-grouped">
                    <p class="control" v-if="metaData || newMetadata">
                      <a class="button is-outlined is-danger is-small" @click="deleteMetaData">{{label.buttons.deleteDetails}}</a>
                    </p>
                    <p class="control" v-else>
                      <a class="button is-outlined is-info is-small" @click="newMetadata = true">{{label.buttons.addDetails}}</a>
                    </p>
                  </div> -->

                  <div class="field is-grouped">
                    <p class="control">
                      <button class="button is-primary" type="submit">{{label.buttons.save}}</button>
                    </p>
                    <p class="control">
                      <a class="button is-light" @click="cancelModal()">{{label.buttons.cancel}}</a>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { AddressService, MetaDataService } from '../services'
import Info from '../components/Info.vue'

export default {
  name: 'MyAddresses',
  components: {
    Info
  },
  data() {
    return {
      uploading: false,
      userAddress: false,
      showEditAddress: false,
      showCreateAddress: false,
      showDetailModal: false,
      addresses: null,
      addressToSubmit: {
        customName: "",
        streetName: "",
        streetNumber: "",
        boxNumber: "",
        postalCode: "",
        localityName: "",
        country: ""
      },
      // used for metadatas
      selectedLocation: null,
      metaData: null,
      editingMetaData: false,
      creatingMetaData: false,
      loadingMetaData: false,
      newMetadata: false,
      metaDataForm: {
        buildingType: '',
        surface: 0,
        constructionYear: 0,
        isLowConsumption: null,
        nbInhabitants: 0,
        hasConvertedAttic: null,
        hasMultipleFloors: null,
        hasVeranda: null,
        isTerracedHouse: null,
        ceilingHeight: 0,
        hasPool: null,
        temperature: 0,
        reduceHeatingWhenAbsent: null,
        alwaysSomeoneAtHome: null,
        useLowConsumptionBulbs: null,
        useAirConditioner: null,
      }
    }
  },
  computed: {
    ...mapState("account", ["user"]),
    ...mapState({ label: state => state.labels.addresses })
  },
  methods: {
    ...mapActions("labels", ["getLabel"]),
    deleteMetaData() {
      if (this.newMetadata) {
        this.newMetadata = false;
        this.resetMetaDataForm();
      } else {
        if(confirm(`${this.label.texts.deleteMetaData} ${this.selectedLocation.customName} ?`)) {
          MetaDataService.deleteMetaData(this.metaData.id, this.selectedLocation.id).then(this.loadMetaData());
        }
      }
    },
    resetMetaDataForm() {
        this.metaData = null;
        this.metaDataForm = {
          buildingType: '',
          surface: 0,
          constructionYear: 0,
          isLowConsumption: null,
          nbInhabitants: 0,
          hasConvertedAttic: null,
          hasMultipleFloors: null,
          hasVeranda: null,
          isTerracedHouse: null,
          ceilingHeight: 0,
          hasPool: null,
          temperature: 20,
          reduceHeatingWhenAbsent: null,
          alwaysSomeoneAtHome: null,
          useLowConsumptionBulbs: null,
          useAirConditioner: null,
        }
    },
    formatRadioValue(radioValue) {
      if (radioValue === true) return this.label.buttons.yes
      if (radioValue === false) return this.label.buttons.no
      else return "--"
    },
    loadMetaData() {
      this.loadingMetaData = true;
      MetaDataService.getLocationMetaData(this.selectedLocation.id).then(location => {
        if(location.metaData) {
          this.metaData = location.metaData;
          this.metaDataForm = {...location.metaData};
        }
        else {
          this.resetMetaDataForm();
        }
        this.loadingMetaData = false;
      });
    },
    deleteLocation(address) {
      if(confirm(`${this.label.texts.delete} "${address.customName}" ?`)) {
        AddressService.deleteLocation(address.id).then(
          (id) => {
            if(!id) {
              alert(this.label.texts.deleteImpossible)
            } else {
              this.loadAddresses();
            }
          },
          () => {
            alert(this.label.texts.deleteImpossible)
          }
        )
      }
    },
    loadAddresses() {
      AddressService.getAddresses(this.user._id)
        .then(addresses => {
          if (addresses) {
            addresses.forEach(address => address.beingEdited = false)
          }
          this.addresses = addresses;
          this.selectedLocation = addresses ? addresses[0] : null;
        });
    },
    openCreateModal() {
      this.userAddress = true;
      this.showCreateAddress = true;
    },
    openDetailModal(location) {
      this.selectedLocation = location;
      this.loadMetaData();
      this.showDetailModal = true;
    },
    openEditModal(address) {
      this.selectedLocation = address;
      this.loadMetaData();
      this.userAddress = address.source == 'user';
      this.showEditAddress = true;
      this.addressToSubmit = { ...address };
    },
    cancelModal() {
      this.showEditAddress = false;
      this.showCreateAddress = false;
      this.showDetailModal = false;
      this.newMetadata = false;
      this.resetMetaDataForm();
      this.addressToSubmit = {
        customName: "",
        streetName: "",
        streetNumber: "",
        boxNumber: "",
        postalCode: "",
        localityName: "",
        country: ""
      }
    },
    submitAddress() {
      if (this.showCreateAddress) {
        // Create address
        AddressService.addAddress({ clientID: this.user._id, ...this.addressToSubmit })
          .then(addressCreated => {
            if (this.newMetadata) MetaDataService.addMetaData(addressCreated.id, this.metaDataForm)
            this.cancelModal();
            this.loadAddresses();
          })
      } else {
        // Edit address
        AddressService.modifyAddress(this.addressToSubmit)
          .then(() => {
            if (this.newMetadata) {
              MetaDataService.addMetaData(this.selectedLocation.id, this.metaDataForm)
            } else {
              MetaDataService.modifyMetaData(this.selectedLocation.id, this.metaDataForm)
            }
            this.cancelModal();
            this.loadAddresses();
          })
      }
    }
  },
  created() {
    this.getLabel({ view: 'addresses' });
    this.loadAddresses();
  }
}
</script>

<style lang="scss" scoped>
.horizontal-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.input-small {
  width: 100px !important;
}

.input-medium {
  width: 200px !important;
}

.input-large {
  width: 300px !important;
}

.field.is-grouped{
  margin-top: 10px;
}

.row-selected {
  background-color: #FAFAFA;
}

.add-address {
  cursor: pointer;

  &:hover {
    background-color: #8796c9;
    color: white;
  }
}

.large-col {
  width: 225px;
}
</style>